import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField, Avatar, IconButton, makeStyles } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import { useCompanyAdmin } from '../../../hooks/CompanyAdmin/useCompanyAdmin'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { Camera } from '@material-ui/icons'
import { config } from '../../../utils/uploadImage'
import S3 from 'react-aws-s3'
import Loader from '../../Loader'
import useValidation from '../../../hooks/Validation/useValidation'
import ActionButton from '../../ActionButton'
import { getImagePreview, ROUTES, sortByName } from '../../../shared/constants'
import CustomSwitch from '../../CustomSwitch'
import SwitchStatus from '../../SwitchStatus'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'
import { CompanyConfigContext } from '../../../context api/Configuration/CompanyConfig'
import { usePermissions } from '../../../hooks/Authentication/usePermissions'
import { handleSingleFile } from '../../../utils/uploadImage';
const useStyles = makeStyles((theme) => ({
  fill: {
    width: '94%',
  },
  large: {
    width: theme.spacing(18),
    height: theme.spacing(18),
  },
  fullWidth: { width: '95%' },
  none: {
    display: 'none',
  },
}))
export default function EmployeeForm1({ form, setForm, edit, addEmployee, location }) {
  const classes = useStyles()
  const { positionEmployees, getEmployeeDetailByPosition } = useCompanyAdmin()
  const {  firstName, lastName, employmentType, dob, phone, email, password, reportingTime, reportingManager, position, rank, address, joiningDate, employeeCode, active, profilePicture, countryCode } = form
  const [imagePreview, setImagePreview] = useState(profilePicture)
  const { permissions } = useContext(CompanyConfigContext)
  const { getAllPermissions } = usePermissions()
  console.log('PROFILE PIC : ', profilePicture)
  console.log('Image Preview : ', imagePreview)
  useEffect(() => {
    getAllPermissions()
  }, [])
  useEffect(() => {
    if (profilePicture) {
      setImagePreview(getImagePreview(profilePicture))
    }
  }, [profilePicture])
  const [progress, setProgress] = React.useState(false)

  const { positions, getAllPositions } = useFeatures()
  //console.log('POSITIONS : ', positions)
  const { error2, handleValidation2, handleValidationMobile, error3, handleValidationEmail, errorEmail } = useValidation()

  const disableButton = firstName && lastName && employmentType && dob && phone && phone.length === 10 && email && reportingTime && reportingManager && position && rank ? false : true

  useEffect(() => {
    if (rank) {
      let tempObj = {}
      Object.keys(location)
        .slice(0, rank - 1)
        .forEach((key) => {
          tempObj[key] = location[key]
        })
      //console.log('TEMO OBJ : ', tempObj)
      getAllPositions({ rank })
      getEmployeeDetailByPosition({ rank, ...tempObj })
    }
  }, [rank])

  // const handleFile = (e) => {
  //   setProgress(true)

  //   if (e.target.files && e.target.files[0]) {
  //     let reader = new FileReader()
  //     reader.onload = (e) => {
  //       setImagePreview(e.target.result)
  //       // setImageUploaded(true)
  //     }
  //     reader.readAsDataURL(e.target.files[0])
  //     const ReactS3Client = new S3(config)
  //     ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}${e.target.files[0].name}`)
  //       .then((data) => {
  //         setForm({ ...form, profilePic: data.location })
  //         //console.log(data.location)
  //         setProgress(false)
  //       })
  //       .catch((err) => {
  //         //console.log(err)
  //         setProgress(false)
  //       })
  //   }
  // }

  const rankOptions = [
    { value: 1, label: 'Regional' },
    { value: 2, label: 'Zonal' },
    { value: 3, label: 'State' },
    { value: 4, label: 'District' },
    { value: 5, label: 'City' },
    { value: 6, label: 'Area' },
  ]

  const employeeTypeOptions = [
    { label: 'Indoor Sales', value: 'INDOOR SALES' },
    { label: 'Outdoor Sales', value: 'OUTDOOR SALES' },
  ]
//  useEffect(()=>{

//  }, [imagePreview])

  const inputFields = [
    {
      type: 'PROFILE',
      name: 'profilePicture',
      imagePreview,
      handleFile: (e) => {
        console.log('file', e.target.files[0])
        // alert("FILES")
        const img = handleSingleFile(e, setProgress, form, setForm)
        setForm({...form, profilePicture: img})
        console.log({form})
        console.log("profile", img)
        setImagePreview(form.profilePicture)
      },
      progress,
    },
    {
      label: 'Employee Code ',
      value: employeeCode,
      name: 'employeeCode',
    },
    {
      label: 'First Name',
      value: firstName,
      name: 'firstName',
    },
    {
      label: 'Last Name',
      value: lastName,
      name: 'lastName',
    },
    { label: 'Date Of Birth', value: dob, name: 'dob', type: 'DATE' },

    {
      value: countryCode,
      name: 'countryCode',
      type: "COUNTRYCODE",
      // conditions: [{ type: 'PHONE' }],
    },
    {
      label: 'Phone Number',
      value: phone,
      name: 'phone',
      conditions: [{ type: 'PHONE' }],
    },
    {
      label: 'Email',
      value: email,
      name: 'email',
      conditions: [{ type: 'EMAIL' }],
    },
    {
      label: 'Password',
      value: password,
      name: 'password',
      noDisplay: edit ? true : false,
      type: 'password',
      conditions: [{ type: 'PASSWORD' }],
    },
    {
      label: 'Select Position',
      value: position,
      name: 'position',
      options: positions,
      disabled: rank ? false : true,
      fieldName: 'positionName',
      fieldValue: '_id',
    },

    {
      label: 'Reporting Manager',
      value: reportingManager,
      name: 'reportingManager',
      options: positionEmployees.sort((a, b) => a.firstName.localeCompare(b.firstName)),
      disabled: rank === 1 ? true : false,
      fieldName: 'firstName',
      fieldValue: '_id',
    },
    {
      label: 'Permissions',
      value: form.permissions,
      name: 'permissions',
      options: sortByName(permissions, 'name'),
      // disabled: rank ? false : true,
      fieldName: 'name',
      fieldValue: '_id',
    },
    {
      label: 'Employment Type ',
      value: employmentType,
      name: 'employmentType',
      options: employeeTypeOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    { label: 'Address', value: address, name: 'address', type: 'ADDRESS' },
    { label: 'Joining Date', value: joiningDate, name: 'joiningDate', type: 'DATE' },
    { label: 'Reporting Time', value: reportingTime, name: 'reportingTime', type: 'TIME' },
    { label: 'Status', value: active, name: 'active', type: 'ACTIVE' },
  ]
  return (
    <CustomAddForm
      state={form}
      setState={setForm}
      data={inputFields}
      address={address}
      setAddress={(val) => {
        setForm({ ...form, address: val })
      }}
      setCoordinates={(ll)=>{
        console.log(ll)
      }}
    />
  )
}
